export class GetUsersBalanceReportReqData {
    branchId: number = -1;
    installationNames: string[] = [];
    startDate: Date = null;
    endDate: Date = null;
    isAccountingDateFilterEnabled: boolean;
    userGroupIds: number[] = [];
    shiftNumbers: string[] = [];

    constructor() {
        this.endDate = new Date();
        this.startDate = new Date();
        // this.startDate.setDate(this.startDate.getDate() - 1);
        // this.endDate.setDate(this.endDate.getDate() - 1);
        (this.startDate as Date).setHours(0, 0, 0, 0);
        (this.endDate as Date).setHours(23, 59, 59, 0);
    }

    public GetReqDataPayload(): GetUsersBalanceReportReqData {
        var res = new GetUsersBalanceReportReqData();
        res.branchId = this.branchId;
        res.isAccountingDateFilterEnabled = this.isAccountingDateFilterEnabled;

        this.installationNames.forEach((element) => {
            res.installationNames.push(element);
        });

        res.startDate = new Date(
            Date.UTC(
                this.startDate.getFullYear(),
                this.startDate.getMonth(),
                this.startDate.getDate(),
                this.startDate.getHours(),
                this.startDate.getMinutes(),
                this.startDate.getSeconds()
            )
        );

        res.endDate = new Date(
            Date.UTC(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate(), this.endDate.getHours(), this.endDate.getMinutes(), this.endDate.getSeconds())
        );

        this.userGroupIds.forEach((element) => {
            res.userGroupIds.push(element);
        });

        this.shiftNumbers.forEach((element) => {
            res.shiftNumbers.push(element);
        });

        return res;
    }
}
